<template>
  <g class="hc-axis" fill="none" font-size="10" :text-anchor="axis.anchor" :transform="transform">
    <path class="hc-axis-domain" :d="drawPath(axis.path)"></path>
    <g 
      v-for="(tick, index) in axis.ticks"
      :key="index"
      class="hc-axis-tick"
      :transform="transformTick(tick.transform)">
      <line
        class="hc-axis-tick-line"
        stroke-dasharray="7,5"
        :x2="tick.line.x2"
        :y2="-offset.bottom - height + data[index].y"
      >
      </line>
      <text
        :transform="'scale(' + scale + ')'"
        :fill="color"
        class="hc-axis-tick-text"
        stroke-width=".1"
        :x="tick.text.x"
        :y="tick.text.y"
        :dy="tick.text.dy + 24 * scale"
      >
        {{tick.text.text}}
      </text>
    </g>
  </g>
</template>

<script>
import { axis } from 'd3-axis-norender'
// import transform from '../addons/transform'
export default {
  name: 'Axis',
  props: {
    scaleFunction: {
      type: Function,
      default () {
        return []
      }
    },
    color: {
      type: String,
      default: '#757575'
    },
    width: {
      type: Number,
      default: 608
    },
    height: {
      type: Number,
      default: 275
    },
    offset: {
      type: Object,
      default () { return { top: 24, left: 48, bottom: 48, right: 48 }}
    },
    scale: {
      type: Number,
      default: 1
    },
    data: {
      type: Array,
      default () { return []}
    }
  },
  methods: {
    transformTick (tick) {
      return `translate(${tick.x}, ${tick.y})`
    },
    drawPath (path) {
      return "M" + (path.range0 - this.offset.left + 18) + "," + path.tick + "V" + (-path.tick) + "V-0.5H" + (path.range1 + this.offset.right - 18) + "V" + path.tick + "V" + (-path.tick)
    }
  },
  computed: {
    axis () {
      return axis(3, this.scaleFunction).ticks(this.data.length).tickFormat(d => d)()
    },
    transform () {
      return `translate(${this.offset.left}, ${this.height + this.offset.bottom})`
    }
  }
}
</script>

<style>

</style>
